import { postCoreDataSecurityAlertsExportSlice } from './post';

export const { requestPostCoreDataSecurityAlertsExport, resetPostCoreDataSecurityAlertsExport } =
	postCoreDataSecurityAlertsExportSlice.asyncActionCreators;
